import { BoolInput } from "../input/BoolInput";
import { InputData } from "../input/InputData";
import { PHPAdress, PHPAdresses } from "../PHPAdress";
import { PHPRequest } from "../PHPRequest";
import { PHPResponse } from "../PHPResponse";
import { CartEntryListResponse } from "./CartEntryListResponse";
import { CartListInput } from "./CartListInput";


export class HideToCartQuestionRequest extends PHPRequest<PHPAdress,BoolInput,PHPResponse>
{
  static readonly adress = PHPAdresses.CART_HIDE_TO_CART_QUESTION

  constructor()
  {
    super( HideToCartQuestionRequest.adress );
  }
}